<cac-dialog-layout
  [title]="data.attributeSet ? 'Edit Attribute set': 'Add New Attributes'"
  subtitle="Enter the required data and save"
  [form]="form"
  (onSubmit)="onSubmit($event)"
>
  <div class="flex flex-col gap-y-4 w-96 pt-4">
    <cac-field [control]="form.controls.name" label="English Name" class="flex-shrink-0" />
    
    <div class="flex flex-col min-h-0 flex-1">
      <h3 class="text-sm font-medium text-gray-900 mb-2 flex-shrink-0">Categories</h3>
      <div class="border rounded-lg p-3 bg-gray-50/50 h-[500px] flex flex-col">
        <app-category-tree 
          [categories]="categories$" 
          [control]="form.controls.categories" 
          [multiple]="true"
          class="flex-1 min-h-0" 
          [isSearchable]="true"
        />
      </div>
    </div>
  </div>
</cac-dialog-layout>